import { render, staticRenderFns } from "./RecordConfig.vue?vue&type=template&id=51010534&scoped=true"
import script from "./RecordConfig.vue?vue&type=script&lang=js"
export * from "./RecordConfig.vue?vue&type=script&lang=js"
import style0 from "./RecordConfig.vue?vue&type=style&index=0&id=51010534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51010534",
  null
  
)

export default component.exports